(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description-bottom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-description-preview')) {
    customElements.define('collection-description-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const content = this.querySelector('.collection-bottom-description__content');
        const preview = this.querySelector('.collection-bottom-description__preview');
        const button = this.querySelector('.collection-bottom-description__toggle');
        if (!content || !preview || !button) return;
        this.initialized = true;
        const text = content.innerText.replace(/\s+/g, ' ').trim();
        const limit = Number(this.dataset.previewLength) || 180;
        if (Array.from(text).length <= limit) return;
        let excerpt = Array.from(text).slice(0, limit).join('');
        const nextCharacter = Array.from(text)[limit];
        const lastSpace = excerpt.lastIndexOf(' ');
        if (nextCharacter !== ' ' && lastSpace > 0) {
          excerpt = excerpt.slice(0, lastSpace);
        }
        preview.textContent = excerpt.trimEnd() + '…';
        preview.hidden = false;
        content.hidden = true;
        button.hidden = false;
        const more = button.querySelector('.collection-bottom-description__more');
        const less = button.querySelector('.collection-bottom-description__less');
        button.addEventListener('click', () => {
          const expand = button.getAttribute('aria-expanded') !== 'true';
          const scrollBack = !expand && this.getBoundingClientRect().top < 0;
          button.setAttribute('aria-expanded', String(expand));
          content.hidden = !expand;
          preview.hidden = expand;
          more.hidden = expand;
          less.hidden = !expand;
          if (scrollBack) this.scrollIntoView({ block: 'start' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
